'use client';

import React from 'react';
import commonStyles from '@/app/(website)/commonStyles.module.scss';
import styles from './interviewArticle.module.scss';

import { Data } from '@strapi/strapi';

type InterviewArticleProps = {
  readonly speakerList: Data.Component<'shared.point-entry'>[];
  readonly speakerTitle?: string;
};

const InterviewArticle: React.FC<InterviewArticleProps> = ({
  speakerList,
  speakerTitle
}) => {
  return (
    <section
      className={`${styles.interviewArticle} ${commonStyles.sectionContent}`}
    >
      <div className={styles.contentContainer}>
        <article className={styles.articleColumn}>
          {speakerList && (
            <div className={styles.articleContent}>
              <h5 className={commonStyles.sectionSubheadingH5}>
                {speakerTitle}
              </h5>
              <ul className={styles.speakerList}>
                {speakerList?.map((speaker) => (
                  <li key={speaker.id} className={styles.speakerBlock}>
                    <p className={commonStyles.sectionBody}>{speaker.title}</p>
                    <p
                      className={`${commonStyles.sectionBody} ${styles.highlight}`}
                    >
                      {speaker.body}
                    </p>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </article>
      </div>
    </section>
  );
};

export default InterviewArticle;
